<!--
 * @Author: zxf
 * @Date: 2023-10-16 15:19:15
 * @LastEditors: zxf
 * @LastEditTime: 2023-10-16 19:55:55
 * @Description: file content
-->
<template>
  <div class="u-ydbj-contains">
    <div class="u-ydbj-zc">
      <span class="u-ydbj-zc_num">{{ xfsbMonth.bj + xfsbMonth.gz + xfsbMonth.qt }}</span>
      <span class="u-ydbj-zc_label">信息总量</span>
    </div>
    <div class="u-ydbj-circle">
      <div class="u-ydbj-wb u-ydbj-circle_item">
        <div style="margin-left: 6px;">
          <img
            id="todoy"
            src="/images/monitor/bj.svg"
          >
          <span class="u-ydbj-circle__label">报警</span>
          <span class="u-ydbj-circle__num">{{ xfsbMonth.bj }}</span>
        </div>
      </div>
      <div class="u-ydbj-zs u-ydbj-circle_item">
        <div style="margin-left: 6px;">
          <img
            id="todoy"
            src="/images/monitor/gz.svg"
          >
          <span class="u-ydbj-circle__label">故障</span>
          <span class="u-ydbj-circle__num">{{ xfsbMonth.gz }}</span>
        </div>
      </div>
      <div class="u-ydbj-ldcs u-ydbj-circle_item">
        <div style="margin-left: 6px;">
          <img
            id="todoy"
            src="/images/monitor/tz.svg"
          >
          <span class="u-ydbj-circle__label">屏蔽</span>
          <span class="u-ydbj-circle__num">{{ xfsbMonth.qt }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ydbjl',
  props: {
    xfsbMonth: {
      type: Object,
      default: () => { return null; }
    }
  }
};
</script>

<style scoped lang="scss">
.u-ydbj-contains{
  height: 170px;
  margin-left: 10px;
  background: url(/images/monitor/ydbj.png) no-repeat left center;
}

.u-ydbj-zc{
  position: relative;
  top: 65px;
  left: 6%;
  width: 72px;
  text-align: center;

  &_num{
    display: block;
    padding-left: 2px;
    font-family: PangMenZhengDao;
    font-size: 22px;
    letter-spacing: 0;
    color: #FFF;
  }

  &_label{
    display: block;
    height: 20px;
    font-family: AlibabaPuHuiTi_2_85_Bold;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0;
    color: #55FAFF;
    text-align: center;

  }
}

.u-ydbj-circle{
  display: flex;
  position: relative;
  left: 30%;
  flex-direction: column;

  img{
    width: 12px;
    height: 12px;
    margin-right: 14px;
  }

  &__label{
    width: 28px;
    height: 20px;
    margin-right: 41px;
    font-family: AlibabaPuHuiTi_2_55_Regular;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    color: #FFF;
  }

  &__num{
    width: 25px;
    height: 18px;
    font-family: PangMenZhengDao;
    font-size: 18px;
    letter-spacing: 0;
    color: #3DFBFF;
  }

  &_item{
    margin: 0 0 12px 10px;
  }
}

</style>
